module.exports = __webpack_public_path__ + "img/ic-nav-menu-popular-casino.057e187c.png";